import Vue from 'vue';
import Router from 'vue-router';
import common from '@/router/common';
import store from '@/store';
import BasicLayout from '@/layouts/BasicLayout';
import { verifyToken } from '@/api/system/auth';
import { getCookies, setCookies, routeListToTree, permissionRequired } from '@/utils/utils';
Vue.use(Router);

export const fixedRouter = [
  {
    path: '/',
    component: BasicLayout,
    redirect: '/navigations'
  },
  ...common
];

export const createRouter = () =>
  new Router({
    mode: 'history',
    routes: fixedRouter
  });
const router = createRouter();

router.beforeEach((to, from, next) => {
  window.document.title = to.meta.title === undefined ? 'DevOps' : `${to.meta.title} - 工程效能平台`;
  const query_token = to.query.token;
  if (query_token) {
    document.cookie = 'token=' + query_token;
    verifyToken({ token: query_token })
      .then(res => {
        window.localStorage.setItem('token', res.data.token);
        window.localStorage.setItem('user_info', JSON.stringify(res.data.user_info));
        // 去除url中的token字段
        const to_query = to.query;
        delete to_query['token'];
        next({ name: to.name, params: to.params, query: to_query });
        // 当使用next函数不能正确跳转显示空白页时，使用如下方法
        // window.location.href = to.fullPath;
      })
      .catch(() => {
        setCookies('token'); // 清除token
        setCookies('refreshToken'); // 清除refreshToken
        window.localStorage.removeItem('token');
        window.localStorage.removeItem('user_info');
        window.location.href = process.env.VUE_APP_SSO_URL + '?url=' + window.location.href;
      });
  }

  router.afterEach((to, from) => {
    // 记录页面浏览事件埋点
    // utils.trackPageview();
  });

  const token = getCookies();
  if (!token) {
    window.location.href = process.env.VUE_APP_SSO_URL + '?url=' + window.location.href;
  }
  if (to.meta.code && to.meta.code.substr(0, 4) === 'page' && !permissionRequired(to.meta.code, to.params.project_id || 0, store.state.permissions)) {
    next({ name: '403' });
  }
  next();
});

const VueRouterPush = Router.prototype.push;
Router.prototype.push = function push(to) {
  return VueRouterPush.call(this, to).catch(err => err);
};

export function resetRouter() {
  const newRouter = createRouter();
  router.matcher = newRouter.matcher; // reset router
}

export function setRouter(routers, projectId = 0) {
  resetRouter();
  const routerList = projectId === 0 ? [...routers] : [...routers[0], ...routers[projectId]];
  const routeAdd = {
    path: '/',
    component: BasicLayout,
    redirect: '/navigations',
    children: routeListToTree(routerList)
  };
  router.addRoute(routeAdd);
  router.addRoute({
    path: '*',
    redirect: '/exception/404'
  });
}

export default router;
